import React, { Component } from 'react';
import './App.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./modules/Layout/Layout";
import Home from "./modules/Home/Home";

import Content from "./modules/Content/Content"; 
import Product from "./modules/Product/Product";
import NoPage from "./modules/NoPage/NoPage";
import Offline from "./modules/Offline/Offline";
import Loading from "./modules/Loading/Loading";
import Welcome from "./modules/Welcome/Welcome";
import SignIn from "./modules/SignIn/SignIn";
import Products from "./modules/Products/Products.js";
import Checkout from "./modules/Checkout/Checkout.js";
import AccountCreate from "./modules/AccountCreate/AccountCreate";
import LostPassword from "./modules/LostPassword/LostPassword.js";
import OfflineCoupons from "./modules/OfflineCoupons/OfflineCoupons.js";
import Contact from "./modules/Contact/Contact.js";
import i18n from './i18n/i18n';
import { AppContext, ModalsContext, withAppContext } from './contexts/AppContext';
import { PushNotifications } from '@capacitor/push-notifications';

import { App as CapacitorApp  } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

import {Utils,AnimatePresenceWrapper,NavigateTo} from './Utils';
import { createBrowserHistory } from 'history';
import { reauthenticateWithCredential } from 'firebase/auth';
import { a, tr } from 'framer-motion/client';

const history = createBrowserHistory();

// Korai token tárolás, ha a natív kód componentDidMount előtt hívná
window.handleEarlyFcmToken = function(token) {
  localStorage.setItem('fcm_token_ready', token);
};

window.init_push_events = function() {
  window.pendingDeepLinkUrl = null; 

  // Segédfüggvény a navigáció retry logikájához
  const tryHandleDeepLink = () => {
      // Hívd meg a React router kezelődet
      if (window.appRef && window.appRef.current && window.appRef.current.handlePendingDeepLink) {
          console.log('Deep Link elindítva az eseményfigyelőből.');
          window.appRef.current.handlePendingDeepLink();
      } else {
          // Ha még nincs kész a komponens, 100ms múlva újrapróbáljuk.
          console.warn('AppRef még nem kész. Deep Link kezelés késleltetve 100ms-al.');
          setTimeout(tryHandleDeepLink, 100);
      }
  };

  const appUrlOpen = (url) => {
    setTimeout(() => {
      console.log('appUrlOpen függvény: ', url);

      if (url) {
          console.log('WINDOW LISTENER: Deep Link Custom Event sikeresen elkapva!', url);

          // 1. URL tárolása
          window.pendingDeepLinkUrl = url;
          
          // 2. Készítsünk egy próbálkozó függvényt a React AppRef eléréséhez
          tryHandleDeepLink(); // Használja a globális retry logikát.

      } else {
          console.warn('WINDOW LISTENER: Deep Link esemény érkezett, de az URL hiányzik.');
      }
    }, 1000);
  };

  const pushReceived = (params) => { 
    const title = params.title;
    const body = params.body;
    const deepLinkUrl = params.deepLinkUrl;

    setTimeout(() => {
      console.log('Foreground Push fogadva! Cím:', title, body, deepLinkUrl, window.appRef.current);

      // Csak akkor folytatjuk, ha az AppRef már elérhető, hogy hívni tudjuk a dialogot
      if (window.appRef && window.appRef.current && !!window.appRef.current.handlePendingDeepLink && !!window.appRef.current.set_dialog_message) {
          
          // A szöveg, amit megjelenítünk
          const dialogMessage = `<b class="push_title">${title}</b><p class="push_body">${body}</p>`;

          // Opciók a párbeszédablakhoz
          const dialogOptions = {
              // Callback funkció a 'OK' gombhoz
              callback: deepLinkUrl ? () => {
                  // A felhasználó rákattintott, indítjuk a navigációt
                  window.pendingDeepLinkUrl = deepLinkUrl;
                  window.appRef.current.handlePendingDeepLink();
              } : null,
              
              // Kijelző gombok: 'OK' és 'Mégse'
              cancel: true, // A 'Mégse' gomb megjelenítéséhez
              push_notification: true // Speciális stílus a push értesítéshez
          };

          // 1. MEGJELENÍTÉS a beépített dialog kezelőddel
          // Az App komponensben a set_dialog_message a 'dialog' state-et állítja be
          window.appRef.current.set_dialog_message(dialogMessage, dialogOptions);

      } else {
          console.warn('Foreground Push érkezett, de az AppRef még nem áll készen a megjelenítésre.');
      }
    }, 1000);
  };

  // !!! Push érkezik az előterében futó alkalmazáshoz.
  window.addEventListener('pushDataReceivedForeground', (e) => {
      const pushData = e.detail.data;
 
      pushReceived({ 
        title: pushData.title, 
        body: pushData.body, 
        deepLinkUrl: pushData.deepLinkUrl 
      });
  });

  // !!! Push érkezik az előterében futó alkalmazáshoz.
  if (Capacitor.isNativePlatform()) {
    PushNotifications.addListener('pushNotificationReceived', (e) => {
        pushReceived({ 
          title: e.title, 
          body: e.body, 
          deepLinkUrl: e.data.deep_link 
        });
    });
  }

  
  // !!! Deep link érkezik, miközben az alkalmazás már fut (elő-, vagy háttérben).
  window.addEventListener('appUrlOpen', (e) => {
      console.log('WINDOW LISTENER: appUrlOpen esemény: ', e);
      appUrlOpen(e.detail.url);
  });

  CapacitorApp.addListener('appUrlOpen', (data) => {
      console.log('WINDOW LISTENER: appUrlOpen esemény: ', data);
      appUrlOpen(data.url);
  });

  // !!! A felhasználó rákattint egy push értesítésre.
  if (Capacitor.isNativePlatform()) PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      console.log('GLOBAL LISTENER: pushNotificationActionPerformed esemény érkezett.');
      
      // Logoljuk a teljes akció adatot hibakeresés céljából
      console.log('Push Action Data:', action); 
      
      // Biztonságos hozzáférés az adatokhoz, ami a notification objektumban van
      const payloadData = action.notification?.data || {}; 
      
      // Kinyerés
      const deepLinkUrl = payloadData['deep_link'] || payloadData['url'] || action.notification?.id; 
      
      console.log('Kinyert Deep Link URL (lehet null):', deepLinkUrl);

      if (deepLinkUrl) {
          window.pendingDeepLinkUrl = deepLinkUrl;
          
          // ✅ JAVÍTVA: Retry logika bevezetve a Push Action eseményhez is.
          tryHandleDeepLink();
      } else {
          console.warn('Push Payload nem tartalmaz Deep Link URL-t a várt kulcsok (deep_link/url) alatt.');
      }
  });

  // !!! Alkalmazás indítása deep linkkel (leállított állapotból).
  // ✅ JAVÍTVA: Retry logika bevezetve a getLaunchUrl híváshoz!
  window.tryGetLaunchUrl = async (attempts = 0) => { 
      if (attempts > 15) { // Max. 3 másodpercet várunk (15 * 200ms)
          console.log('GLOBAL LAUNCHURL: A Deep Link időtúllépés miatt elmaradt (max 3s).');
          return;
      }

      const ret = await CapacitorApp.getLaunchUrl();

      //console.log(`GLOBAL LAUNCHURL: getLaunchUrl eredménye (Próba ${attempts}):`, ret);

      if (ret && ret.url) {
          window.pendingDeepLinkUrl = ret.url;
          
          // Elindítjuk a navigációt a meglévő AppRef ellenőrzéssel
          if (window.appRef && window.appRef.current && window.appRef.current.handlePendingDeepLink) {
              console.log('GLOBAL LAUNCHURL: Deep Link sikeresen elindítva.');
              window.appRef.current.handlePendingDeepLink();
          } else {
              // Ha az AppRef még nem készült el, de a link már megérkezett a Swift kódból.
              //console.warn('GLOBAL LAUNCHURL: AppRef még nem kész. Késleltetett kezelés.');
              setTimeout(() => window.tryGetLaunchUrl(attempts + 1), 200);
          }
      } else {
          // Ha a link még nem elérhető (a Swift 3.0s delay még fut).
          //console.warn('GLOBAL LAUNCHURL: URL még nem érhető el. Újrapróbálkozás...');
          setTimeout(() => window.tryGetLaunchUrl(attempts + 1), 200);
      }
  }

  // Indítjuk a lekérdezést
  window.tryGetLaunchUrl();
}

CapacitorApp.addListener('appStateChange', (state) => {
  // Csak akkor kell hívni, ha az app előtérbe kerül (a háttérből)
  if (state.isActive) {

    // a felfüggesztés alatt elmaradt scroll/resize események miatt beragadhat a fejléc
    // elrejtett állapota vagy a --vh magasság, ezért visszatéréskor újraszinkronizáljuk
    window.appRef?.current?.sync_view_state();

    setTimeout(() => {
      console.log('Capacitor App: App előtérbe került (isActive = true). Lekérdezzük a Deep Linket.');
      // Ez hívja meg a globálisan definiált retry logikát.
      window.tryGetLaunchUrl();
    }, 3000);
  }
});

window.init_push_events();

class App extends Component {

  // külső js css fájlok betöltésének nyilvántartása
  third_party = {};

  productsRef = new React.createRef();
  
  dialogRef = new React.createRef();

  currency_settings = {};

  product_url = '';

  state = { 
    is_online: window.navigator.onLine,

    // componentDidMount
    initialized: false,

    // get_initial_data
    menus: null, 
    categories: null, 
    is_signed: 0,
    login_ready: 0, // amíg ez 0 addig a betöltő képernyő jelenik meg
    dialog: '',
    dialog_options: {},
    user_data: {},
    home_card_slide: 0,
    sale_url: {},
    subscribed_to_newsletter: 0,
    favorites: [],
    unread_messages: 0,
    navigate_back: false,
    others: {}, // egyéb beállítások backendről
    page_scrolled: false,
    category_picker_active_key: 'home',
    selectedSublevels: {}, // főkategóriánként tárolja az utoljára kiválasztott 2. szintű kategóriát
 
    // get_settings
    settings: null, 
    
    current_lang: '',
    fcm_token: '',
  };

  static page_scrolled_threshold = 10;

  // A kontextus használata osztálykomponensekben
  static contextType = ModalsContext;
  
  product_menu_opened = false;

  setProductMenuOpened(opened)
  {
    this.product_menu_opened = opened;
  }

  handleAppBack()
  {
    let modal_closed = false;
    const modals = this.context;
    
    if (modals) {
      Object.keys(modals).map((key,val)=>{
      
      const modal = modals[key];
      
      if(modal?.current?.state?.show && !modal_closed){
        modal.current.hide();
        modal_closed = true;
        return true;
      }

      });
    }

    if(!modal_closed)
    {
      this.setState({navigate_back:true},()=>{
        this.setState({navigate_back:false});
      })
    }
  }

  openDialog(){
    if (this.dialogRef.current) this.dialogRef.current.showModal();
  };

  closeDialog(){
    if (this.dialogRef.current){
      this.dialogRef.current.close();
      this.setState({dialog:''});
    }
  };

  is_online() {
    return this.state.is_online;
  }

  get_is_signed() {
    return this.state.is_signed;
  }

  logout() {

    Utils.get_server_data('', { ajax_event:'logoff', APICACHE:'false' }, { ajax_event: 'logoff' })
      .then((res)=>{
        if (res.success === true) {
          this.reset_signed_state();
        }
      });
  }

  /**
   * Bejelentkezett állapot teljes visszaállítása a frontenden (localStorage + state + almenük).
   * Akkor használjuk, amikor a szerveroldali munkamenet már megszűnt (kilépés, regisztráció törlése).
   */
  reset_signed_state() {

    Utils.localSorageSetWithExpiry('remember_hash_' + this.current_lang, '');

    this.setState({is_signed: 0, logout_now: 1},()=>{
      let user_data = this.state.user_data;

      this.setState({logout_now:0, user_data: user_data});

      // A modalsContext-ből vegye a referenciákat (az AppHeaderRef is ott van, nem az appContext-ben)
      const modalsContext = this.context;

      if(modalsContext?.AppHeaderRef?.current){
        modalsContext.AppHeaderRef.current.setState({signed:0});
      }

      if(modalsContext?.ProfileMenuRef?.current){
        modalsContext.ProfileMenuRef.current.setState({is_signed:0});
      }
      if(modalsContext?.AppFooterMenuRef?.current){
        modalsContext.AppFooterMenuRef.current.set_is_signed();
      }
    });
  }
  
  handleLoginSuccess(res, success_callback) {
    // A modalsContext-ből vegye a referenciákat
    const modalsContext = this.context;

    if(modalsContext?.AppHeaderRef?.current){
      modalsContext.AppHeaderRef.current.setState({signed:1});
    }
    
    // A modalsContext-ből vegye a ProfileMenuRef-et
    if(modalsContext?.ProfileMenuRef?.current){
      modalsContext.ProfileMenuRef.current.setState({is_signed:1});
    }
              
    // ha bejelölte a checkboxot és php oldalon sikerült is a hírlevél feliratkozás, akkor rögzítjük localstorage-ban, hogy a következő loginnál már ne jelenjen meg a checkbox
    if (parseInt(res.subscribed_to_newsletter) === 1) {
      Utils.localSorageSetWithExpiry('login_newsletter_sent_' + this.current_lang, 1, Number.MAX_SAFE_INTEGER);
    }

    // új remember_hash beállítása localstorage-ban
    if (typeof res.remember_hash != 'undefined' && !!res.remember_hash.length)
    {
        Utils.localSorageSetWithExpiry('remember_hash_' + this.current_lang, res.remember_hash, this.remember_me_expire);
    }

    const settings = this.state.settings || {};

    settings.display_fcm_token = res.display_fcm_token;

    this.setState({
      is_signed: 1, 
      login_ready: 1, 
      user_data: res.user_data,
      unread_messages: res.unread_messages,
      subscribed_to_newsletter: res.subscribed_to_newsletter,
      setting: settings,
    }, () => {
      if(modalsContext.AppFooterMenuRef?.current){
        modalsContext.AppFooterMenuRef.current.set_is_signed();
      } 
    });

    
    if(typeof success_callback==='function'){
      success_callback(res);
    }
    

    //belépés után lekédezzük a kosarat
    //@todo ha meglesz az güyfélkártya adat akkor itt át kell adni paraméterbe: post_data['select_ugyfelkartya'] = loyalti_code;
    Utils.get_update_shopping_cart(null,true);
  }

  login(auto_login_with_hash = false,form_data,stored_hash,success_callback,faild_callback) {

    const post_data = {
      ajax_event: 'login',
      auto_login_with_hash: auto_login_with_hash ? '1' : '0',
      remember_hash: stored_hash ? stored_hash : '',
    };

    if(form_data)
    {
      Object.assign(post_data, form_data);
    }
    
    Utils.get_server_data(
      '',
      {
        ajax_event:'login',
        APICACHE:'false'
      }, 
      post_data
    )
    // hiba esetén is le kell futnia a visszahívásnak, különben a rá váró hívások (Utils.login_promise) beragadnak
    .catch((err)=>{

      console.error('login', err);

      return {error_request: true};

    })
    .then((res)=>{

      if (res?.success_sign_in)
      {
        this.handleLoginSuccess(res, success_callback);
      }
      else
      {
        this.setState({login_ready: 1}, () => {

          if(typeof faild_callback==='function'){
            faild_callback(res);
          }
        });
      }

    });
  }


  get_update_shopping_cart(shoppingcart,is_init){
    
    if(shoppingcart===undefined)
    {
      Utils.get_server_data('', { ajax_event:'get_shoppingcart', APICACHE:'false' })
      .then((res)=>{

        const update_state = {};

        if(res?.shopping_cart){  
          update_state['shopping_cart'] = res.shopping_cart;
        }
        
        if(res?.dialog_message){
          update_state['dialog'] = res.dialog_message;
        }

        this.setState(update_state, () => {           
          this.update_cart_components(is_init);
          window.dispatchEvent(new CustomEvent('shopping_cart_updated', { detail: res.shopping_cart }));
        });

      });
    }
    else
    {
      this.setState({'shopping_cart':shoppingcart}, () => {
        this.update_cart_components(is_init);
        window.dispatchEvent(new CustomEvent('shopping_cart_updated', { detail: shoppingcart }));
      });
    }

  }

  update_cart_components(is_init)
  {
    // A modalsContext-ből vegye a modál referenciákat
    const modalsContext = this.context;
    
    /*if(modalsContext?.PopupAddedToCartRef?.current && !is_init){
      modalsContext.PopupAddedToCartRef.current.show(this.state.shopping_cart.pc_sum); 
    }*/
    
    
    // Frissítjük a fejlécet is (Minicart) - az AppHeaderRef a modalsContext-ben van
    if(modalsContext?.AppHeaderRef?.current){
      modalsContext.AppHeaderRef.current.forceUpdate();
    }

    if(modalsContext.ShoppingCartRef?.current){
      modalsContext.ShoppingCartRef.current.set_shopping_cart(this.state.shopping_cart);
    }
  }

  set_dialog_message(msg, options = {})
  {
    this.setState({'dialog':msg, 'dialog_options': options},()=>{
      this.openDialog();
    });
  }

  get_shopping_cart(){
    return this.state.shopping_cart;
  }

  product_fav_add(e, params = {}) 
  {   
    if (e)
    {
      e.preventDefault();
    }

    const favorites = this.state.favorites;
    const product = typeof params.product !== 'undefined' ? params.product : null;
    const on_resolve = typeof params.on_resolve !== 'undefined' ? params.on_resolve : () => {};

    if(!this.state.is_signed){
      return;
    }

    /*
    var webshop_event = (fav.hasClass('active')) ? 'add_favorite' : 'delete_favorite';
    var ajax_data = 'webshop_event='+webshop_event+'&sql_id_product='+pid+'&ajax_event=change_in_favorites';
*/

    if (product)
    {
      Utils.get_server_data(
        '',
        {
          ajax_event:'add_favorite',
          APICACHE:'false'
        }, 
        {
          ajax_event: 'add_favorite',
          webshop_event: 'add_favorite',
          sql_id_product: product.id,
        }
      )
      .then((res) => {
        product.fav = 1;
        favorites.push(product);

        this.setState({favorites}, () => on_resolve(res, product));
      });
    }
  }

  product_fav_delete(e, params = {}) 
  {   
    if (e)
    {
      e.preventDefault();
    }

    let favorites = this.state.favorites;
    const product = typeof params.product !== 'undefined' ? params.product : null;
    const on_resolve = typeof params.on_resolve !== 'undefined' ? params.on_resolve : () => {};

    if (product)
    {
      Utils.get_server_data(
        '',
        {
          ajax_event:'delete_favorite',
          APICACHE:'false'
        }, 
        {
          ajax_event: 'delete_favorite',
          webshop_event: 'delete_favorite',
          sql_id_product: product.id,
        }
      )
      .then((res) => {
        favorites = favorites.filter(fav => parseInt(fav.id) !== parseInt(product.id));
        this.setState({favorites}, () => on_resolve(res, product));
      });
    }
  }

  is_favorite_product(product) {
    let result = false;

    if (this.state.favorites)
    {
      this.state.favorites.forEach(fav => {
        if (parseInt(fav.id) === parseInt(product.id))
        {
          result = true;
        }
      })
    }

    return result;
  }

  isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  render() {
    let result = '';
   
    const routing_base_path = process.env.PUBLIC_URL.replace(window.location.origin,'');
    const isAndroid = this.isAndroid();
    const scrolled = this.state.page_scrolled;

    // nincs internet
    if(!this.state.is_online)
    {
      result = (<div className={"application_wrapper" + (isAndroid ? " is-android" : "") + (scrolled ? " is-scrolled" : "") }><Offline/></div>);
    } 
    // alapvető adatok még nem kerültek letöltésre
    else if(!this.state.initialized)
    {
      result = (<div className={"application_wrapper" + (isAndroid ? " is-android" : "") + (scrolled ? " is-scrolled" : "") }><Loading/></div>);
    }
    else
    {
      result = <>

        <div id='AppMainContainer' className={"application_wrapper" + (isAndroid ? " is-android" : "") + (scrolled ? " is-scrolled" : "") }>
          
        {this.render_dialog()}

        <BrowserRouter basename={routing_base_path}>          
          {this.state.logout_now ? <NavigateTo toURL='/'></NavigateTo> : ''}
          {this.state.navigate_back ? <NavigateTo toURL={-1}></NavigateTo> : ''}
          <AnimatePresenceWrapper>
            <Routes>
              <Route path="/" element={<Layout />}> 
                <Route index element={<Home />} />
                <Route path='home/*' element={<Home />} />
                <Route path="sign-in/*" element={
                  <ModalsContext.Consumer>
                    {modalsContext => <SignIn ref={modalsContext?.SignInRef} hidden={false} />}
                  </ModalsContext.Consumer>
                } />
                <Route path="account_create/*" element={<AccountCreate />} />
                <Route path="lost-password/*" element={<LostPassword />} />
                <Route path="content/*" element={<Content />} />
                {/* az admin banner-típus listbox 'contents' értéket ad, ugyanez a tartalmi oldal */}
                <Route path="contents/*" element={<Content />} />
                <Route path="product/*" element={<Product />} />
                <Route path='products/*' element={<Products />}/>
                <Route path='checkout/*' element={<Checkout />}/>
                <Route path='contact/*' element={<Contact />}/>
                <Route path='offline-coupons/*' element={<OfflineCoupons />}/>
                <Route path='favorites/*' element={<Products isFavorites={true} />}/>
                <Route path="*" element={<NoPage />} />
              </Route>
            </Routes>
          </AnimatePresenceWrapper>
        </BrowserRouter>
        </div>

      </>
    }

    return result;
  }

  render_dialog() {
    const { dialog, dialog_options } = this.state;

    if (!dialog) return '';

    const okBtnConditionalProps = {};

    okBtnConditionalProps.onClick = () => {
      this.closeDialog();

      if (!!dialog_options.callback) {
        dialog_options.callback();
      }
    };

    const handleBackdropClick = (e) => {
      // Bezárás ha a backdrop-ra (dialog elem külső területe) kattintottak
      if (e.target === this.dialogRef.current) {
        this.closeDialog();
      }
    };
    
    return  <dialog id="dialog" ref={this.dialogRef} onClick={handleBackdropClick}>
      {typeof dialog === 'string' ? 
        <p dangerouslySetInnerHTML={{__html: dialog}}></p> : 
        dialog
      }
      {!dialog_options.hide_buttons ? 
      <>
        <button id="close" {...okBtnConditionalProps} >{i18n.t('shoppingcartMessageDialogClose')}</button>
        {dialog_options.cancel ? <button id="close" onClick={()=>{this.closeDialog()}}>{i18n.t('dialogCancel')}</button> : ''}
      </> : ''
      }
    </dialog>;
  }

  componentDidMount() {
    window.appRef = { current: this };

    this.handleDeepLink(window.location.href);

    var that = this;

      // Felülírjuk a korai placeholder verziót a valódi logikával
    window.handleEarlyFcmToken = function(token) {
      console.log('handleEarlyFcmToken', token);
      localStorage.setItem('fcm_token_ready', token);
      that.setState({fcm_token: token});
    };

    // Ha a natív kód componentDidMount előtt hívta, vesszük a tárolt tokent
    const earlyToken = localStorage.getItem('fcm_token_ready');
    if (earlyToken) {
      that.setState({fcm_token: earlyToken});
    }

    // Globális függvény az Android/iOS native back gomb kezeléséhez
    window.handleAppBack = () => this.handleAppBack();

    document.addEventListener('scroll', this.scroll_content, true);
    document.addEventListener('visibilitychange', this.handle_visibility_change);

    this.initializeApp();
    
    // Service Worker frissítés ellenőrzése 30 percenként
    this.checkForServiceWorkerUpdate();
    this.swUpdateInterval = setInterval(() => {
      this.checkForServiceWorkerUpdate();
    }, 30 * 60 * 1000); // 30 perc
    
  }

  getFCMToken() {
    const { fcm_token } = this.state;

    return fcm_token;
  }

  handlePendingDeepLink() {
    if (window.pendingDeepLinkUrl) {
        const url = window.pendingDeepLinkUrl;
        window.pendingDeepLinkUrl = null; // Csak egyszer használjuk
        this.handleDeepLink(url);
    }
}

  handleDeepLink(url) {
    
    try {
        if(url.indexOf('deeplink')!==-1){ 
          /*
          // Győződj meg róla, hogy minden szükséges csere megtörténik
          let processedUrl = url.replace('://', '://app.').replace('app.app.', 'app.').replace('/deeplink', '');//.replace('dorko.hu', 'uf2.netgo-dev.hu');
          const finalUrl = new URL(processedUrl);
          
          // 2. Navigáció: Az URL.href használata helyett próbáljuk a hash-t is kezelni
          if (finalUrl) {
            if (Capacitor.isNativePlatform()) {
              console.log("Navigáció indítása Universal Linkkel:", finalUrl.href);
              window.location.replace(finalUrl.href);
          }*/

          // Az útvonal kinyerése (pl: /products/valami)
          const pathWithParams = url.replace('://', '://app.').replace('app.app.', 'app.').split('/deeplink')[1]; 
          
          if (pathWithParams) {
              console.log("Navigáció belső history-val:", pathWithParams);
              
              // window.location.replace helyett:
              history.push(pathWithParams); 
              
              // Kényszerítjük a BrowserRouter-t, hogy észlelje a változást
              window.dispatchEvent(new PopStateEvent('popstate'));
          }

        } else {
          console.warn("Ismeretlen deeplink formátum, navigáció kihagyva:", url);
        }
    } catch (e) {
        console.warn("Hiba a Universal Link URL feldolgozásakor:", url, e);
    }
  }

  componentWillUnmount() {
    if (this.swUpdateInterval) {
      clearInterval(this.swUpdateInterval);
    }

    document.removeEventListener('scroll', this.scroll_content, true);
    document.removeEventListener('visibilitychange', this.handle_visibility_change);
  }

  checkForServiceWorkerUpdate() {
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {

      // Ha a SW vált (új aktiválódott), töltjük újra az oldalt az új bundle-ért
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      }, { once: true });

      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration) {
          registration.update().then(() => {
            // Ha van várakozó SW (új verzió letöltve), aktiváljuk
            if (registration.waiting) {
              registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
            // Ha még tölt, figyeljük mikor kerül waiting állapotba
            registration.addEventListener('updatefound', () => {
              const newWorker = registration.installing;
              if (newWorker) {
                newWorker.addEventListener('statechange', () => {
                  if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                  }
                });
              }
            });
          });
        }
      });
    }
  }

  initializeApp(force=false){
    if(!this.state.initialized || force) 
    {
      this.state.initialized = true;

      this.current_lang =  i18n.resolvedLanguage;
 
      Utils.setCookie('react-app-version', process.env.REACT_APP_JS_VERSION, 0); 

      Utils.get_server_data('',{'ajax_event':'get_initial_data','APICACHE':'false'}).then((resp_initial)=>{

        // sikertelen kérés esetén nem indulhat el az app üres adatokkal (eltűnő menüsor, üres kosár),
        // marad a betöltő képernyő és újrapróbáljuk
        if (!resp_initial || resp_initial.error_request)
        {
          this.state.initialized = false;
          setTimeout(() => this.initializeApp(), 3000);
          return;
        }

        this.product_url = resp_initial.products_url ? resp_initial.products_url : '';

        this.setState({

          is_signed: parseInt(resp_initial?.logged_in) == 1 ? 1: 0,
          login_ready: parseInt(resp_initial?.logged_in) == 1 ? 1: 0,
          menus: resp_initial?.menus ? resp_initial.menus : [],
          categories: resp_initial?.categories ? resp_initial.categories : [],
          shopping_cart: resp_initial?.shopping_cart ? resp_initial.shopping_cart : [],
          subscribed_to_newsletter: resp_initial?.subscribed_to_newsletter,
          user_data: resp_initial?.user_data ? resp_initial.user_data : {},
          sale_url: resp_initial?.sale_url,
          favorites: [], 
          others: resp_initial?.others ? resp_initial.others : {},
          unread_messages: parseInt(resp_initial?.unread_messages),
          initialized: true

        }, () => {

          this.get_update_shopping_cart(undefined,true);
          
          this.get_settings()
            .then((resp_settings) => {

              if(resp_settings && resp_settings.currency_settings){
                this.currency_settings = resp_settings.currency_settings;
              }

              if(resp_settings && resp_settings.settings){
                this.setState({settings: resp_settings.settings}, () => {

                  this.is_signed = this.state.is_signed;
                  this.remember_me_expire = resp_settings.remember_me_expire;
                  const remember_hash = Utils.localSorageGetWithExpiry('remember_hash_' + this.current_lang);
                  this.stored_hash = remember_hash ? remember_hash : '';
                  
                  if(this.is_signed)
                  {
                    this.setState({is_signed: 1});
                  }
                  
                  this.setState({login_ready:1});
                  
                  // ha nincs feliratkozva hírlevélre, akkor a legközelebbi loginnál meg kell jeleníteni a checkboxot
                  if (this.state.is_signed)
                  {
                    const login_newsletter_sent = Utils.localSorageGetWithExpiry('login_newsletter_sent_' + this.current_lang);

                    if (parseInt(resp_initial.subscribed_to_newsletter) == 0 && login_newsletter_sent)
                    {
                      Utils.localSorageSetWithExpiry('login_newsletter_sent_' + this.current_lang, 0);
                    }
                    else if(parseInt(resp_initial.subscribed_to_newsletter) == 1) {
                      Utils.localSorageSetWithExpiry('login_newsletter_sent_' + this.current_lang, 1, Number.MAX_SAFE_INTEGER);
                    }
                  }

                  this.handleUrlHash(); // deeplink kezelése
                  this.handlePendingDeepLink();
                });
              }
            });

          Utils.get_server_data('',{'ajax_event':'get_favorites','APICACHE':'false'}).then((resp_fav)=>{
            this.setState({favorites: resp_fav.favorites || []});
          });

        });

      });

      this.init_events();
    }
  }

  /**
   * deeplink kezelése
   */
  handleUrlHash() 
  {
    const hash = window.location.hash;
    const key = '#app://page/';

    if (hash && hash.indexOf(key) !== -1){
      const url = hash.replace(key, '');

      history.push('/' + url);
      window.location.href = process.env.PUBLIC_URL + '/' + url;
    }
  }

  get_settings()
  {
    //először cacheből kérjük le 
    return Utils.get_server_data('',{'CacheFirst':'true','ajax_event':'get_settings'});
  }

  get_favorites() {
    return this.state.favorites;
  }

  set_is_online = function(is_online){
    this.setState({is_online:is_online});
  }

  init_events(){

    // Hálózat állapotváltásakor a state frissítése
    window.ononline = ()=>{
      this.set_is_online(true);
    }

    // Hálózat állapotváltásakor a state frissítése
    window.onoffline = ()=>{
      this.set_is_online(false);
    }

  }

  // előtérbe kerüléskor (natív appStateChange nélküli környezetben is) újraszinkronizáljuk a nézetet
  handle_visibility_change = ()=>{
    if (document.visibilityState === 'visible') {
      this.sync_view_state();
    }
  }

  /**
   * A scroll a mindenkori oldal-konténeren történik, ami útvonalváltáskor kicserélődik, és a scroll esemény
   * nem buborékol - ezért egyetlen capture fázisú listenert kötünk be, ami minden konténert lefed.
   */
  scroll_content = (e)=>{
    // csak az aktuális oldal konténere számít, a modálok (szintén .container) görgetése nem
    if (!e?.target || e.target !== this.get_page_container()) {
      return;
    }

    this.set_scrolled_from_container(e.target);
  }

  get_page_container = ()=>{
    return document.querySelector('.application_wrapper > .container');
  }

  // a fejléc állapotát mindig az élő konténer scroll pozíciójából számoljuk
  set_scrolled_from_container = (container = null)=>{
    const element = container || this.get_page_container();

    this.set_scrolled(!!element && element.scrollTop > App.page_scrolled_threshold);
  }

  /**
   * Az app előtérbe kerülésekor a nézet állapotának újraszinkronizálása.
   * A WebView felfüggesztése alatt elmaradhatnak a scroll/resize események, és a fejléc
   * elrejtett állapota vagy a --vh magasság hibásan beragadhat.
   */
  sync_view_state = ()=>{
    Utils.sync_viewport();
    this.set_scrolled_from_container();
  }

  set_scrolled = (scrolled)=>{
    if (this.state.page_scrolled === scrolled) return; // felesleges újrarenderelés elkerülése

    this.setState({page_scrolled:scrolled});
  }

  change_language = (lang_to='')=>{

    if(!lang_to){
      lang_to = (i18n.resolvedLanguage==='hu') ? 'en' : 'hu';
    }
  
    i18n.changeLanguage(lang_to);
    this.setState({current_lang:i18n.resolvedLanguage})
  }
}

// Exportáljuk az App-ot az AppContext-tel együtt
export default withAppContext(App);
